import React, { useEffect } from 'react';
import { Button, Tabs } from 'antd';
import type { TabsProps } from 'antd';
import s from './s.module.less';
import Benefits from './Benefits';
import FAQComponent from './FAQ';
import HowItWork from './HowItWork';
import Frame from './imgs/Frame.png';
import SureIcon from 'assets/common/sure.png';
import ConfirmPaymentModal from './ConfirmPaymentModal';
import { IPaymentInfo } from 'types/common';

enum ESection {
    BENEFITS = 'benefits',
    FAQ = 'faq',
    HOW_IT_WORKS = 'howItWorks',
}

type Props = {
    isModal?: boolean;
    paymentInfo?: IPaymentInfo | undefined;
    onPaymentInfoChange?: () => void;
    onPaidPrescriptions?: () => void
};

const PrescriptionsLandingPage = (props: Props) => {
    const { isModal, paymentInfo, onPaymentInfoChange, onPaidPrescriptions } = props;
    const [activeId, setActiveId] = React.useState(ESection.BENEFITS);
    const [isScrolling, setIsScrolling] = React.useState(false);
    const [showConfirmPaymentModal, setShowConfirmPaymentModal] = React.useState(false);

    useEffect(() => {

    }, []);

    const guideItems: TabsProps['items'] = [
        {
            key: ESection.BENEFITS,
            label: <div>Benefits</div>,
            children: <div />,
        },
        {
            key: ESection.HOW_IT_WORKS,
            label: <div>How it works</div>,
            children: <div />,
        },
        {
            key: ESection.FAQ,
            label: <div>FAQs</div>,
            children: <div />,
        },
    ];

    const handleChange = (activeKey: string) => {
        setIsScrolling(true);
        setActiveId(activeKey as ESection);
        const element = document.getElementById(activeKey as string);
        const wrapElement = document.getElementById('contentWrap');
        wrapElement?.scrollTo({
            top: (element as HTMLBaseElement).offsetTop - 150,
            behavior: 'smooth',
        });
        setIsScrolling(false);
    };

    React.useEffect(() => {
        const wrap = document.getElementById('contentWrap');
        const first = document.getElementById(ESection.BENEFITS);
        const second = document.getElementById(ESection.HOW_IT_WORKS);
        const third = document.getElementById(ESection.FAQ);
        const handle = () => {
            const top = wrap?.scrollTop;
            const slug = 500;
            if (third && top && (top + slug) > third?.offsetTop) {
                setActiveId(ESection.FAQ);
            } else if (second && top && (top + slug) > second?.offsetTop) {
                setActiveId(ESection.HOW_IT_WORKS);
            } else {
                setActiveId(ESection.BENEFITS);
            }
        };
        wrap?.addEventListener('scroll', handle);
        return () => {
            wrap?.removeEventListener('scroll', handle);
        };
    }, []);

    return (
        <div
            className={`${s.wrap} ${isModal ? s.wrapModal : ''}`}
            id="contentWrap"
        >
            <div className={s.header}>
                <div className={s.left}>
                    <div className={s.title}>
                        Prescribe any medication to any network pharmacy with <span style={{ color: '#0E62F4' }}>Klarity E-Prescriptions</span><br />
                        <div className={s.icon}>
                            (Powered by
                            <img src={SureIcon} />
                            )
                        </div>
                    </div>
                    <div className={s.des}>
                        Send prescriptions seamlessly with Klarity E-Prescriptions powered by ScriptSure—fast, secure, compliant, and fully integrated into your daily workflow, all for just <span style={{ fontWeight: 700 }}>$36 per month</span>.
                    </div>
                    {
                        !isModal && (
                            <div className={s.startBtn}>
                                <Button
                                    type="primary"
                                    onClick={() => {
                                        setShowConfirmPaymentModal(true);
                                    }}
                                >Get started
                                </Button>
                            </div>
                        )
                    }

                </div>
                <div className={s.right}>
                    <img src={Frame} />
                </div>
            </div>
            <div className={s.tabs}>
                <Tabs
                    activeKey={activeId}
                    items={guideItems}
                    onChange={(activeKey) => handleChange(activeKey)}
                />
            </div>
            <div className={s.content} id={ESection.BENEFITS}>
                <Benefits />
            </div>
            <div className={s.content} id={ESection.HOW_IT_WORKS}>
                <HowItWork />
            </div>
            <div className={s.content} id={ESection.FAQ}>
                <FAQComponent />
            </div>
            <ConfirmPaymentModal
                paymentInfo={paymentInfo}
                onPaymentInfoChange={onPaymentInfoChange}
                price={36}
                onSuccess={() => {
                    setShowConfirmPaymentModal(false);
                    onPaidPrescriptions?.();
                }}
                open={showConfirmPaymentModal}
                onClose={() => setShowConfirmPaymentModal(false)}
            />
        </div>
    );
};

export default PrescriptionsLandingPage;
